export const brand = [
  // { v: "0", country: "원산지", brand: "제조사를 선택하세요" },
  { v: "1", country: "국산차", brand: "현대" },
  { v: "2", country: "국산차", brand: "제네시스" },
  { v: "3", country: "국산차", brand: "기아" },
  { v: "4", country: "국산차", brand: "쉐보레" },
  { v: "5", country: "국산차", brand: "쌍용" },
];

export const model = [
  { brand: "제조사를 선택하세요", model: "차종을 선택하세요" },
  { brand: "현대", model: "I30" },
  { brand: "현대", model: "I40" },
  { brand: "현대", model: "그랜저" },
  { brand: "현대", model: "넥쏘" },
  { brand: "현대", model: "맥스크루즈" },
  { brand: "현대", model: "베뉴" },
  { brand: "현대", model: "베르나" },
  { brand: "현대", model: "벨로스터" },
  { brand: "현대", model: "소나타" },
  { brand: "현대", model: "스타렉스" },
  { brand: "현대", model: "스타리아" },
  { brand: "현대", model: "싼타페" },
  { brand: "현대", model: "아반떼" },
  { brand: "현대", model: "아슬란" },
  { brand: "현대", model: "아이오닉" },
  { brand: "현대", model: "에쿠스" },
  { brand: "현대", model: "엑센트" },
  { brand: "현대", model: "캐스퍼" },
  { brand: "현대", model: "코나" },
  { brand: "현대", model: "투싼" },
  { brand: "현대", model: "팰리세이드" },
  { brand: "제네시스", model: "제네시스" },
  { brand: "기아", model: "EV6" },
  { brand: "기아", model: "K3" },
  { brand: "기아", model: "K5" },
  { brand: "기아", model: "K7" },
  { brand: "기아", model: "K8" },
  { brand: "기아", model: "K9" },
  { brand: "기아", model: "니로" },
  { brand: "기아", model: "레이" },
  { brand: "기아", model: "모닝" },
  { brand: "기아", model: "모하비" },
  { brand: "기아", model: "셀토스" },
  { brand: "기아", model: "스토닉" },
  { brand: "기아", model: "스팅어" },
  { brand: "기아", model: "스포티지" },
  { brand: "기아", model: "쎄라토" },
  { brand: "기아", model: "쏘렌토" },
  { brand: "기아", model: "쏘울" },
  { brand: "기아", model: "카니발" },
  { brand: "기아", model: "카렌스" },
  { brand: "기아", model: "포르테" },
  { brand: "기아", model: "프라이드" },
  { brand: "쉐보레", model: "라세티" },
  { brand: "쉐보레", model: "말리부" },
  { brand: "쉐보레", model: "볼트" },
  { brand: "쉐보레", model: "스파크" },
  { brand: "쉐보레", model: "아베오" },
  { brand: "쉐보레", model: "알페온" },
  { brand: "쉐보레", model: "올란도" },
  { brand: "쉐보레", model: "이쿼녹스" },
  { brand: "쉐보레", model: "임팔라" },
  { brand: "쉐보레", model: "카마로" },
  { brand: "쉐보레", model: "콜로라도" },
  { brand: "쉐보레", model: "크루즈" },
  { brand: "쉐보레", model: "트랙스" },
  { brand: "쉐보레", model: "트레버스" },
  { brand: "쉐보레", model: "트레일블레이저" },
  { brand: "쌍용", model: "체어맨" },
];

export const goods = [
  {
    model_1: "차종을 선택하세요",
    model_2: "세부 차종을 선택하세요",
    year: "",
    product: "",
    link: "",
  },
  {
    brand: "현대",
    model_1: "I30",
    model_2: "i-30(GD)",
    year: "2011.10~2015.01",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "I30",
    model_2: "더뉴i-30(GD)",
    year: "2015.01~2016.12",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "I30",
    model_2: "i-30(PD)",
    year: "2016.09~",
    product: "DP105",
    size: "235*195*28",
    link: "http://dblock.kr/surl/P/169",
  },
  {
    brand: "현대",
    model_1: "I40",
    model_2: "i-40",
    year: "2011.09~",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "현대",
    model_1: "그랜저",
    model_2: "그랜저HG",
    year: "2011.01~2016.10",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "현대",
    model_1: "그랜저",
    model_2: "그랜저HG HEV",
    year: "2013.12~2017.02",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "현대",
    model_1: "그랜저",
    model_2: "그랜저IG",
    year: "2016.11~2019",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "현대",
    model_1: "그랜저",
    model_2: "그랜저IG HEV",
    year: "2017.03~2019",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "현대",
    model_1: "그랜저",
    model_2: "더 뉴 그랜저IG",
    year: "2019.11~2022",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "현대",
    model_1: "그랜저",
    model_2: "디 올 뉴 그랜저GN7",
    year: "2022.11~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "현대",
    model_1: "넥쏘",
    model_2: "넥쏘 수소차",
    year: "2018.03~",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "현대",
    model_1: "맥스크루즈",
    model_2: "맥스크루즈",
    year: "2013.03~2015.09",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "현대",
    model_1: "맥스크루즈",
    model_2: "더 뉴 맥스크루즈",
    year: "2015.09~2018.12.",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "현대",
    model_1: "베뉴",
    model_2: "베뉴",
    year: "2019.07~",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "베르나",
    model_2: "베르나 트랜스폼(MC)",
    year: "2009.06~2010.11",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "벨로스터",
    model_2: "벨로스터",
    year: "2011.03~2015.01",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "현대",
    model_1: "벨로스터",
    model_2: "더뉴벨로스터",
    year: "2015.01~2017.12",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "현대",
    model_1: "벨로스터",
    model_2: "벨로스터(JS)",
    year: "2018.02~2022",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "벨로스터",
    model_2: "벨로스터N(JS)",
    year: "2018.06~2022",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "소나타",
    model_2: "YF소나타",
    year: "2009.09~2014.03",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "현대",
    model_1: "소나타",
    model_2: "YF소나타 HEV",
    year: "2011.05~2014.12",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "현대",
    model_1: "소나타",
    model_2: "LF소나타",
    year: "2014.03~2017.03",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "현대",
    model_1: "소나타",
    model_2: "LF소나타 HEV",
    year: "2014.12~2017.04",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "현대",
    model_1: "소나타",
    model_2: "LF소나타 뉴라이즈",
    year: "2017.03~2019.02",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "현대",
    model_1: "소나타",
    model_2: "LF소나타 뉴라이즈 HEV",
    year: "2017.05~2019.02",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "현대",
    model_1: "소나타",
    model_2: "소나타 DN8",
    year: "2019.03~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "현대",
    model_1: "스타렉스",
    model_2: "더뉴 그랜드 스타렉스 2018",
    year: "2017.12~2021",
    product: "DP118",
    size: "118*200*30",
    link: "http://dblock.kr/surl/P/179",
  },
  {
    brand: "현대",
    model_1: "스타리아",
    model_2: "스타리아",
    year: "2021.04~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "현대",
    model_1: "싼타페",
    model_2: "싼타페 더 프라임",
    year: "2012.06~2018.08",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "현대",
    model_1: "싼타페",
    model_2: "싼타페 DM",
    year: "2015.05~2015.11",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "현대",
    model_1: "싼타페",
    model_2: "싼타페 TM",
    year: "2018.02~",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "현대",
    model_1: "싼타페",
    model_2: "더뉴 싼타페",
    year: "2020.07~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "현대",
    model_1: "아반떼",
    model_2: "아반떼HD",
    year: "2006.05~2010.08",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "아반떼",
    model_2: "아반떼HD HEV",
    year: "2009.07~2013.11",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "아반떼",
    model_2: "아반떼MD",
    year: "2010.08~2013.08",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "아반떼",
    model_2: "아반떼MD 쿠페",
    year: "2013.04~2015.06",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "아반떼",
    model_2: "더 뉴 아반떼MD",
    year: "2013.08~2015.11",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "아반떼",
    model_2: "아반떼AD",
    year: "2015.09~2018.09",
    product: "DP105",
    size: "235*195*28",
    link: "http://dblock.kr/surl/P/169",
  },
  {
    brand: "현대",
    model_1: "아반떼",
    model_2: "더 뉴 아반떼AD",
    year: "2018.09~2020.03",
    product: "DP105",
    size: "235*195*28",
    link: "http://dblock.kr/surl/P/169",
  },
  {
    brand: "현대",
    model_1: "아반떼",
    model_2: "올 뉴 아반떼 CN7",
    year: "2020.04~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "현대",
    model_1: "아슬란",
    model_2: "아슬란",
    year: "2014.10.~2018.01",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "현대",
    model_1: "아이오닉",
    model_2: "아이오닉 EV",
    year: "2016.06~",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "아이오닉",
    model_2: "아이오닉 HEV",
    year: "2016.01~2019.01",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "아이오닉",
    model_2: "아이오닉 PHEV",
    year: "2017.02~2019.01",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "현대",
    model_1: "아이오닉",
    model_2: "더 뉴 아이오닉 HEV",
    year: "2019.01~",
    product: "DP105",
    size: "235*195*28",
    link: "http://dblock.kr/surl/P/169",
  },
  {
    brand: "현대",
    model_1: "아이오닉",
    model_2: "아이오닉 5",
    year: "2021.~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "현대",
    model_1: "아이오닉",
    model_2: "아이오닉 6",
    year: "2022.~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "현대",
    model_1: "에쿠스",
    model_2: "뉴 에쿠스(VI)",
    year: "2009.03~2015.12",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "현대",
    model_1: "엑센트",
    model_2: "엑센트(RB) (2010~2017)",
    year: "2010.~2017",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "현대",
    model_1: "엑센트",
    model_2: "엑센트(RB) (2018~)",
    year: "2018.05~2019.07",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "캐스퍼",
    model_2: "캐스퍼(AX1)",
    year: "2021.~",
    product: "DP116",
    size: "177*175*28",
    link: "http://dblock.kr/surl/P/178",
  },
  {
    brand: "현대",
    model_1: "코나",
    model_2: "코나",
    year: "2017.06~2020.09",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "코나",
    model_2: "코나 EV",
    year: "2018.04~2023.03",
    product: "DP105",
    size: "235*195*28",
    link: "http://dblock.kr/surl/P/169",
  },
  {
    brand: "현대",
    model_1: "코나",
    model_2: "코나 HEV",
    year: "2019.08~2023.01",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "코나",
    model_2: "더뉴코나",
    year: "2020.10~2023.01",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "코나",
    model_2: "더뉴코나 HEV",
    year: "2020.10~2023.01",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "코나",
    model_2: "더뉴코나 N라인",
    year: "2021.07~",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "투싼",
    model_2: "투싼",
    year: "2004.03~2009.08",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "현대",
    model_1: "투싼",
    model_2: "투싼IX",
    year: "2009.08~2013.05",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "현대",
    model_1: "투싼",
    model_2: "올뉴투싼",
    year: "2015.03~2018.11",
    product: "DP113",
    size: "220*200*28",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "투싼",
    model_2: "투싼 신형(TL)",
    year: "2018.08~2020.09",
    product: "DP113",
    size: "220*200*28",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "현대",
    model_1: "투싼",
    model_2: "투싼 NX4",
    year: "2020.10~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "현대",
    model_1: "투싼",
    model_2: "투싼 NX4 하이브리드",
    year: "2020.10~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "현대",
    model_1: "팰리세이드",
    model_2: "팰리세이드",
    year: "2018.12~",
    product: "DP104",
    size: "236*212*28",
    link: "http://dblock.kr/surl/P/168",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "제네시스 쿠페",
    year: "2008.10~2011.11",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "더 뉴 제네시스 쿠페",
    year: "2011.11~2016.08",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "제네시스 (BH)",
    year: "2008.01~2013.11",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "제네시스 (DH 전기형)",
    year: "2013.11~2016.07",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "제네시스 EQ900 (HI 전기형)",
    year: "2015.12~2018.11",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "GV60 (JW1)",
    year: "2021.09~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "G70 (IK)",
    year: "2017.09~2020.10",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "더 뉴 G70 (IK PE)",
    year: "2020.10~",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "GV70 (JK1)",
    year: "2020.~",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "Electrified GV70 (JK1 EV)",
    year: "2022.~",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "G80 (DH 후기형)",
    year: "2016.07~2020.01",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "G80 (RG3)",
    year: "2020.03~",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "Electrified G80 (RG3 EV)",
    year: "2021.07~",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "G90 (HI PE)",
    year: "2018.11~2021.12",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "G90 (RS4)",
    year: "2021.12~",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "제네시스",
    model_1: "제네시스",
    model_2: "GV80 (JX1)",
    year: "2020.01~",
    product: "DP107",
    size: "223*255*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "기아",
    model_1: "EV6",
    model_2: "EV6",
    year: "2021.08~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "K3",
    model_2: "K3 (YD)",
    year: "2012.09~2015.11",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "기아",
    model_1: "K3",
    model_2: "K3 쿱 (YD)",
    year: "2013.08~2016.03",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "기아",
    model_1: "K3",
    model_2: "더 뉴 K3 (YD)",
    year: "2015.11~2018.05",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "기아",
    model_1: "K3",
    model_2: "올 뉴 K3 (BD)",
    year: "2018.02~",
    product: "DP105",
    size: "235*195*28",
    link: "http://dblock.kr/surl/P/169",
  },
  {
    brand: "기아",
    model_1: "K3",
    model_2: "K3 3세대",
    year: "2018.10~",
    product: "DP105",
    size: "235*195*28",
    link: "http://dblock.kr/surl/P/169",
  },
  {
    brand: "기아",
    model_1: "K3",
    model_2: "K3 GT (BD)",
    year: "2018.10~",
    product: "DP105",
    size: "235*195*28",
    link: "http://dblock.kr/surl/P/169",
  },
  {
    brand: "기아",
    model_1: "K5",
    model_2: "K5 (TF)",
    year: "2010.04~2013.06",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "기아",
    model_1: "K5",
    model_2: "K5 HEV (TF)",
    year: "2011.05~2015.12",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "기아",
    model_1: "K5",
    model_2: "더 뉴 K5 (TF)",
    year: "2013.06~2015.07",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "기아",
    model_1: "K5",
    model_2: "올 뉴 K5 HEV (JF)",
    year: "2015.12~2018.04",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "기아",
    model_1: "K5",
    model_2: "더 뉴 k5 HEV (JF)",
    year: "2018.01~",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "기아",
    model_1: "K5",
    model_2: "올 뉴 K5 (JF)",
    year: "2015.07~2018.01",
    product: "DP114",
    size: "192*222*30",
    link: "http://dblock.kr/surl/P/176",
  },
  {
    brand: "기아",
    model_1: "K5",
    model_2: "더 뉴 K5 (JF)",
    year: "2018.01~",
    product: "DP114",
    size: "192*222*30",
    link: "http://dblock.kr/surl/P/176",
  },
  {
    brand: "기아",
    model_1: "K5",
    model_2: "K5 DL3",
    year: "2019.12~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "K5",
    model_2: "K5 DL3 HEV",
    year: "2019.12~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "K7",
    model_2: "K7 (VG)",
    year: "2009.11~2012.11",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "기아",
    model_1: "K7",
    model_2: "더 뉴 K7 (VG)",
    year: "2012.11~2016.01",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "기아",
    model_1: "K7",
    model_2: "K7 HEV (VG)",
    year: "2013.12~2016.12",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "기아",
    model_1: "K7",
    model_2: "올 뉴 K7 (YG)",
    year: "2016.01~",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "기아",
    model_1: "K7",
    model_2: "올 뉴 K7 HEV (YG)",
    year: "2016.11~",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "기아",
    model_1: "K7",
    model_2: "K7 프리미어",
    year: "2019.06~",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "기아",
    model_1: "K7",
    model_2: "K7 프리미어 HEV",
    year: "2019.06~",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "기아",
    model_1: "K8",
    model_2: "K8",
    year: "2021.04~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "K8",
    model_2: "K8 HEV",
    year: "2021.05~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "K9",
    model_2: "더K9",
    year: "2018.04~",
    product: "DP107",
    size: "255*223*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "기아",
    model_1: "니로",
    model_2: "니로 EV",
    year: "2018.07~",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "기아",
    model_1: "니로",
    model_2: "니로 HEV",
    year: "2016.03~2019.02",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "기아",
    model_1: "니로",
    model_2: "더 뉴 니로 HEV",
    year: "2019.03~2021.12",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "기아",
    model_1: "니로",
    model_2: "니로 플러스(DE PBV EV)",
    year: "2022.~",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "기아",
    model_1: "니로",
    model_2: "더 올 뉴니로 HEV(SG2)",
    year: "2022.01~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "레이",
    model_2: "레이",
    year: "2011.11~2018.03",
    product: "DP115",
    size: "175*173*12",
    link: "http://dblock.kr/surl/P/177",
  },
  {
    brand: "기아",
    model_1: "레이",
    model_2: "더 뉴 레이",
    year: "2017.12~",
    product: "DP115",
    size: "175*173*12",
    link: "http://dblock.kr/surl/P/177",
  },
  {
    brand: "기아",
    model_1: "레이",
    model_2: "더 뉴 기아 레이",
    year: "2022.~",
    product: "DP115",
    size: "175*173*12",
    link: "http://dblock.kr/surl/P/177",
  },
  {
    brand: "기아",
    model_1: "모닝",
    model_2: "모닝 (SA)",
    year: "2004.02~2008.01",
    product: "DP115",
    size: "175*173*12",
    link: "http://dblock.kr/surl/P/177",
  },
  {
    brand: "기아",
    model_1: "모닝",
    model_2: "뉴 모닝 (SA)",
    year: "2008.01~2011.01",
    product: "DP115",
    size: "175*173*12",
    link: "http://dblock.kr/surl/P/177",
  },
  {
    brand: "기아",
    model_1: "모닝",
    model_2: "올 뉴 모닝 (TA)",
    year: "2011.01~2015.01",
    product: "DP115",
    size: "175*173*12",
    link: "http://dblock.kr/surl/P/177",
  },
  {
    brand: "기아",
    model_1: "모닝",
    model_2: "더 뉴 모닝 (TA)",
    year: "2015.01~2016.",
    product: "DP115",
    size: "175*173*12",
    link: "http://dblock.kr/surl/P/177",
  },
  {
    brand: "기아",
    model_1: "모닝",
    model_2: "올 뉴 모닝 (JA)",
    year: "2017.01~",
    product: "DP116",
    size: "177*175*28",
    link: "http://dblock.kr/surl/P/178",
  },
  {
    brand: "기아",
    model_1: "모닝",
    model_2: "모닝 어반",
    year: "2020.05~",
    product: "DP116",
    size: "177*175*28",
    link: "http://dblock.kr/surl/P/178",
  },
  {
    brand: "기아",
    model_1: "모하비",
    model_2: "모하비",
    year: "2008.01~2015.12",
    product: "DP109",
    size: "208*238*18",
    link: "http://dblock.kr/surl/P/172",
  },
  {
    brand: "기아",
    model_1: "모하비",
    model_2: "더뉴 모하비",
    year: "2016~2019.09",
    product: "DP109",
    size: "208*238*18",
    link: "http://dblock.kr/surl/P/172",
  },
  {
    brand: "기아",
    model_1: "모하비",
    model_2: "모하비 더 마스터",
    year: "2019.09~",
    product: "DP104",
    size: "236*212*28",
    link: "http://dblock.kr/surl/P/168",
  },
  {
    brand: "기아",
    model_1: "셀토스",
    model_2: "셀토스",
    year: "2019.07~",
    product: "DP113",
    size: "220*200*28",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "기아",
    model_1: "스토닉",
    model_2: "스토닉",
    year: "2017.07~",
    product: "DP113",
    size: "220*200*28",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "기아",
    model_1: "스팅어",
    model_2: "스팅어",
    year: "2017.05~2020.",
    product: "DP107",
    size: "255*223*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "기아",
    model_1: "스팅어",
    model_2: "스팅어마이스터",
    year: "2020.08~2023.",
    product: "DP107",
    size: "255*223*30",
    link: "http://dblock.kr/surl/P/171",
  },
  {
    brand: "기아",
    model_1: "스포티지",
    model_2: "스포티지 (NB)",
    year: "1993.07~2002.09",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "스포티지",
    model_2: "뉴 스포티지 (JE/KM)",
    year: "2004.08~2010.03",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "스포티지",
    model_2: "스포티지R (SL)",
    year: "2010.03~2013.07",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "스포티지",
    model_2: "더 뉴 스포티지R (SL)",
    year: "2013.07~2015.09",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "스포티지",
    model_2: "올 뉴 스포티지 (QL)",
    year: "2015.09~2018.07",
    product: "DP113",
    size: "220*200*28",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "기아",
    model_1: "스포티지",
    model_2: "스포티지 더 볼드 (QL)",
    year: "2018.07~2021.07",
    product: "DP113",
    size: "220*200*28",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "기아",
    model_1: "스포티지",
    model_2: "디 올 뉴 스포티지 (NQ5)",
    year: "2021~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "스포티지",
    model_2: "디 올 뉴 스포티지 하이브리드 (NQ5)",
    year: "2021~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "쎄라토",
    model_2: "쎄라토",
    year: "2003.11~2006.07",
    product: "DP109",
    size: "208*238*18",
    link: "http://dblock.kr/surl/P/172",
  },
  {
    brand: "기아",
    model_1: "쎄라토",
    model_2: "뉴 쎄라토",
    year: "2006.07~2008.08",
    product: "DP109",
    size: "208*238*18",
    link: "http://dblock.kr/surl/P/172",
  },
  {
    brand: "기아",
    model_1: "쏘렌토",
    model_2: "쏘렌토R",
    year: "2009.04~2012.07",
    product: "DP109",
    size: "208*238*18",
    link: "http://dblock.kr/surl/P/172",
  },
  {
    brand: "기아",
    model_1: "쏘렌토",
    model_2: "뉴 쏘렌토R",
    year: "2012.07~2014.08",
    product: "DP109",
    size: "208*238*18",
    link: "http://dblock.kr/surl/P/172",
  },
  {
    brand: "기아",
    model_1: "쏘렌토",
    model_2: "올 뉴 쏘렌토",
    year: "2014.08~2017.07",
    product: "DP104",
    size: "236*212*28",
    link: "http://dblock.kr/surl/P/168",
  },
  {
    brand: "기아",
    model_1: "쏘렌토",
    model_2: "더 뉴 쏘렌토",
    year: "2017.07~",
    product: "DP104",
    size: "236*212*28",
    link: "http://dblock.kr/surl/P/168",
  },
  {
    brand: "기아",
    model_1: "쏘렌토",
    model_2: "쏘렌토MQ4",
    year: "2020.03~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "쏘렌토",
    model_2: "쏘렌토MQ4 하이브리드",
    year: "2020.03~",
    product: "DP111",
    size: "225*210*30",
    link: "http://dblock.kr/surl/P/173",
  },
  {
    brand: "기아",
    model_1: "쏘울",
    model_2: "쏘울 부스터",
    year: "2019.01~",
    product: "DP113",
    size: "222*202*30",
    link: "http://dblock.kr/surl/P/175",
  },
  {
    brand: "기아",
    model_1: "카니발",
    model_2: "그랜드 카니발",
    year: "2005.07~2010.01",
    product: "DP109",
    size: "208*238*18",
    link: "http://dblock.kr/surl/P/172",
  },
  {
    brand: "기아",
    model_1: "카니발",
    model_2: "뉴 카니발/카니발R",
    year: "2006.01~2014",
    product: "DP109",
    size: "208*238*18",
    link: "http://dblock.kr/surl/P/172",
  },
  {
    brand: "기아",
    model_1: "카니발",
    model_2: "올 뉴 카니발",
    year: "2014.06~2018.02",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "기아",
    model_1: "카니발",
    model_2: "더 뉴 카니발",
    year: "2018.03~2023.",
    product: "DP112",
    size: "252*225*20",
    link: "http://dblock.kr/surl/P/174",
  },
  {
    brand: "기아",
    model_1: "카니발",
    model_2: "카니발 KA4",
    year: "2020.07~",
    product: "DP103",
    size: "252*225*28",
    link: "http://dblock.kr/surl/P/167",
  },
  {
    brand: "기아",
    model_1: "카렌스",
    model_2: "뉴 카렌스",
    year: "2006.04~2013.03",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "카렌스",
    model_2: "올 뉴 카렌스",
    year: "2013.03~2016.08",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "기아",
    model_1: "카렌스",
    model_2: "더 뉴 카렌스",
    year: "2016.07~2018.10",
    product: "DP102",
    size: "238*195*20",
    link: "http://dblock.kr/surl/P/166",
  },
  {
    brand: "기아",
    model_1: "포르테",
    model_2: "포르테",
    year: "2008.08~2012.09",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "포르테",
    model_2: "포르테 HEV",
    year: "2009.07~2013.",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "포르테",
    model_2: "포르테 쿱",
    year: "2009.06~2013.",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "프라이드",
    model_2: "프라이드",
    year: "2005.04~2011.09",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "프라이드",
    model_2: "올 뉴 프라이드",
    year: "2011.09~2014.12",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "기아",
    model_1: "프라이드",
    model_2: "더 뉴 프라이드",
    year: "2014.12~2017.08",
    product: "DP106",
    size: "200*220*17",
    link: "http://dblock.kr/surl/P/170",
  },
  {
    brand: "쉐보레",
    model_1: "라세티",
    model_2: "라세티 프리미어",
    year: "2008.10~2011.03",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "말리부",
    model_2: "말리부",
    year: "2011.11~2016.11",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "말리부",
    model_2: "올 뉴 말리부",
    year: "2016.04~",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "말리부",
    model_2: "더 뉴 말리부",
    year: "2018.11~",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "볼트",
    model_2: "볼트 EV",
    year: "2017.04~",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "볼트",
    model_2: "볼트 HEV",
    year: "2017.02~2019.03",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "스파크",
    model_2: "스파크(M300)",
    year: "2013~2015",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "스파크",
    model_2: "더 넥스트 스파크",
    year: "2015.08~2018.04",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "스파크",
    model_2: "더 뉴 스파크",
    year: "2018.05",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "아베오",
    model_2: "아베오 (T300)",
    year: "2011.03~2016.12",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "아베오",
    model_2: "더 뉴 아베오",
    year: "2016.09~2019.03",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "알페온",
    model_2: "알페온",
    year: "2010.09~2017.11",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "올란도",
    model_2: "올란도",
    year: "2011.03~2018.07",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "이쿼녹스",
    model_2: "이쿼녹스",
    year: "2018~",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "임팔라",
    model_2: "임팔라",
    year: "2015.08~2020.",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "카마로",
    model_2: "카마로SS",
    year: "2016.06~2018.11",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "콜로라도",
    model_2: "콜로라도",
    year: "2019.08~",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "크루즈",
    model_2: "크루즈",
    year: "2011.03~2015.01",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "크루즈",
    model_2: "뉴 크루즈",
    year: "2015.01~2017.11",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "크루즈",
    model_2: "올 뉴 크루즈",
    year: "2017.01~2018.10",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "트랙스",
    model_2: "트랙스",
    year: "2013.02~2016.12",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "트랙스",
    model_2: "더 뉴 트랙스",
    year: "2016.10~",
    product: "DP201",
    size: "200*235*35",
    link: "http://dblock.kr/surl/P/180",
  },
  {
    brand: "쉐보레",
    model_1: "트레버스",
    model_2: "트레버스",
    year: "2019.09~",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쉐보레",
    model_1: "트레일블레이저",
    model_2: "트레일블레이저",
    year: "2020.01~",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쌍용",
    model_1: "체어맨",
    model_2: "체어맨(구형)",
    year: "1997.10~2003.09",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쌍용",
    model_1: "체어맨",
    model_2: "뉴 체어맨",
    year: "2003.09~2008.01",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쌍용",
    model_1: "체어맨",
    model_2: "체어맨 H",
    year: "2008.01~2011.05",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
  {
    brand: "쌍용",
    model_1: "체어맨",
    model_2: "체어맨 H 뉴 클래식",
    year: "2011.05~2014.12",
    product: "DP202",
    size: "200*240*30",
    link: "http://dblock.kr/surl/P/181",
  },
];
